import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  input,
} from '@angular/core';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { AdvancedFiltersService } from '@qaroni-core/services/app/advanced-filters/advanced-filters.service';

@Component({
  selector: 'qaroni-advanced-filters-button',
  templateUrl: './advanced-filters-button.component.html',
  styleUrl: './advanced-filters-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AdvancedFiltersButtonComponent
  extends QarepaBaseSubsDirective
  implements OnInit, OnDestroy
{
  readonly isDisabled = input<boolean>(false);

  private advancedFiltersService = inject(AdvancedFiltersService);
  private advancedFilterStatus$ =
    this.advancedFiltersService.getAdvancedFiltersStatus$();

  public active: boolean = false;

  ngOnInit(): void {
    this.subs.add(this.advancedFilterStatus$.subscribe(this.getStatus));
  }

  ngOnDestroy(): void {
    this.advancedFiltersService.changeStatus(false);
  }

  get icon(): string {
    return this.active ? 'filter_list_off' : 'filter_list';
  }

  public onClick(): void {
    this.active = !this.active;
    this.advancedFiltersService.changeStatus(this.active);
  }

  private getStatus = (status: boolean): void => {
    this.active = status;
  };

  get tooltipText(): string {
    return this.active
      ? $localize`Ocultar filtros`
      : $localize`Mostrar filtros`;
  }
}
